<template>
  <div>
    <div class="page-wrapper">
      <div class="page-content-wrapper">
        <div class="shadow-btm">
          <div class="row col-lg-6 col-sm-6 my-auto">
            <h4 class="mb-0 lg-bld">Manage Admins</h4>
          </div>
        </div>
        <div
          class="page-content"
          v-show="accessObject?.is_view == 1 || !isShowAccessDeniedMessage"
        >
          <div class="card-body py-0 px-0">
            <div class="row">
              <div class="col-lg-6 col-sm-6 form-group row">
                <div class="has-search ml-3">
                  <i
                    class="fa fa-search"
                    style="position: absolute; margin: 11px"
                    aria-hidden="true"
                  ></i>
                  <input
                    type="text"
                    class="form-control"
                    v-on:keyup.enter="getList(0)"
                    placeholder="Search"
                    v-model="searchObj.keyword"
                  />
                </div>
                <a
                  class="fill-btn btn-style cursor-pointer ml-3"
                  v-on:click="getList(0)"
                  >Search</a
                >
                <a
                  class="fill-btn btn-style cursor-pointer"
                  v-on:click="resetFilter"
                  v-show="searchObj.keyword"
                  >Reset</a
                >
              </div>
              <div
                style="cursor: pointer"
                class="col-lg-6 col-sm-6 txt-right form-group"
              >
                <a
                  v-show="accessObject?.can_create == 1"
                  class="fill-btn cursor-pointer"
                  style="padding: 11px; margin-right: 16px"
                  v-on:click="$router.push('/add-admin')"
                  >+ Add</a
                >
              </div>
            </div>
            <div class="card border mb-0 radius-15">
              <div class="card-body p-0 pb-4">
                <div class="table-responsive">
                  <div class="dataTables_wrapper dt-bootstrap4">
                    <table
                      class="table table-striped table-bordered dataTable"
                      style="width: 100%"
                      role="grid"
                      aria-describedby="example_info"
                    >
                      <thead>
                        <tr role="row">
                          <th>Sr. No.</th>
                          <th
                            class="sorting"
                            id="id-first_name"
                            v-on:click="sorting('first_name', 'id-first_name')"
                          >
                            Name
                          </th>
                          <th
                            class="sorting"
                            id="id-email"
                            v-on:click="sorting('email', 'id-email')"
                          >
                            Email
                          </th>
                          <!-- <th class="sorting" id="id-phone_number" v-on:click="sorting('mobile', 'id-phone_number')">Mobile</th> -->
                          <th
                            class="sorting"
                            id="id-role"
                            v-on:click="sorting('role', 'id-role')"
                          >
                            Role
                          </th>
                          <th
                            v-if="
                              accessObject?.can_update == 1 ||
                              accessObject?.can_delete == 1
                            "
                          >
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody v-show="!loader">
                        <tr v-for="(data, index) in list" :key="index">
                          <td style="text-align: left">
                            {{
                              ($refs.listPagination.currentPage - 1) * 10 +
                              index +
                              1
                            }}
                          </td>
                          <td style="text-align: left">
                            {{ data.full_name ? data.full_name : "-" }}
                          </td>
                          <td style="text-align: left">
                            {{ data.email ? data.email : "-" }}
                          </td>
                          <!-- <td style="text-align:left;">{{ data.phone_number ? data.phone_number : "-" }}</td> -->
                          <td style="text-align: left">
                            {{
                              data.role && data.role.role ? data.role.role : "-"
                            }}
                          </td>
                          <td
                            v-if="
                              accessObject?.can_update == 1 ||
                              accessObject?.can_delete == 1
                            "
                          >
                            <a
                              v-if="accessObject?.can_update == 1"
                              class="fill-btn btn-style cursor-pointer"
                              v-on:click="
                                $router.push('/edit-admin/' + data.uuid)
                              "
                              >Edit</a
                            >
                            <a
                              v-if="
                                data.isShow && accessObject?.can_delete == 1
                              "
                              class="fill-btn btn-style cursor-pointer"
                              v-on:click="showDeletePopup(data)"
                              >Delete</a
                            >
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="row mx-0 mb-4">
                  <div class="col-lg-12 mt-5 text-center">
                    <div class="page-bottom-pagination text-right">
                      <Pagination
                        @page-change="pageChange"
                        @items-per-page-change="itemsPerPageChange"
                        ref="listPagination"
                      />
                    </div>
                  </div>
                </div>
                <ErrorComponent @retry="getList(0)" ref="errorComponent" />
              </div>
            </div>
          </div>
        </div>
        <!-- <div
          class="text-center"
          style="margin-top: 20%"
          v-show="accessObject?.is_view == 0 || isShowAccessDeniedMessage"
        >
          <h3>You do not have access to view admin</h3>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import ErrorComponent from "@/components/ErrorComponent";
import Pagination from "@/components/Pagination";
import swal from "sweetalert2";
export default {
  name: "Admin",
  components: {
    ErrorComponent,
    Pagination,
  },
  data() {
    return {
      accessObject: this.$helperService.getAccessLevel("manage_admin_users"),
      loader: true,
      isShowAccessDeniedMessage: false,
      searchObj: {
        keyword: "",
      },
      offset: -1,
      list: [],
      uuid: localStorage.getItem("user_id"),
    };
  },
  mounted() {
    // if (!this.accessObject) {
    //   this.isShowAccessDeniedMessage = true;
    //   this.$router.push("/access-denied");
    //   return;
    // }
    this.$helperService.showMenu("true");
    this.getList(0);
  },
  methods: {
    pageChange(offset) {
      this.getList(offset - 1);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(0);
    },
    getList(page, orderBy, sortBy) {
      this.$refs.errorComponent.updateListLoader(true);
      this.list = [];
      this.searchObj.offset = page;
      if (orderBy) {
        this.searchObj.order_by = orderBy;
      }
      if (sortBy) {
        this.searchObj.sort_by = sortBy;
      }
      this.$api
        .getAPI({
          _action: "/admin-users",
          _body: this.searchObj,
        })
        .then((res) => {
          this.loader = false;
          this.list = res.list;
          this.offset = res.next_offset;
          for (var i in this.list) {
            this.list[i].isShow = true;
            if (this.list[i].id == 1) {
              this.list[i].isShow = false;
            }
            if (this.list[i].uuid == this.uuid) {
              this.list[i].isShow = false;
            }
          }
          this.accessObject =
            this.$helperService.getAccessLevel("manage_admin_users");
          if (page == 0) {
            if (this.$refs.listPagination) {
              if (res.count != null && res.count > 0) {
                this.$refs.listPagination.setTotalCount(res.count);
              } else {
                this.$refs.listPagination.setTotalCount(0);
              }
            }
          }
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(res, "No data available");
            this.$refs.errorComponent.updateListLoader(false);
          }
        })
        .catch(() => {
          this.loader = false;
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(0, undefined, "");
            this.$refs.errorComponent.updateListLoader(false);
          }
        });
    },
    sorting(sortBy, id) {
      var obj = this.$helperService.sorting(sortBy, id);
      this.getList(0, obj.order_by, obj.sort_by);
    },
    resetFilter() {
      this.searchObj.keyword = "";
      this.getList(0);
    },
    showDeletePopup(data) {
      swal
        .fire({
          title: "Are you sure?",
          text: "Are you sure you want to delete " + data.first_name,
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            this.$api
              .deleteAPI({
                _action: "/admin-user/" + data.uuid,
              })
              .then((res) => {
                if (res) {
                  this.getList(0);
                  this.$notify({
                    type: "success",
                    text: res.message,
                  });
                }
              })
              .catch(() => {
                this.$refs.deleteModal.removeLoader();
              });
          }
        });
    },
  },
};
</script>

